import {
  maxMobile,
  maxWidth, primaryColor, primaryFont, retina, wMedium,
} from 'Utils/utilsStyle';
import { useNavigate } from 'react-router-dom';
import React from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import { scrollWithId } from 'Utils/UtilityFunctions';

const Wrapper = styled.span`
 &.disabledViewMore {
    pointer-events: none;
    cursor: no-drop;
    opacity: 0.5;
  }
  font-family: ${primaryFont};
  color: #fff;
  font-weight: ${wMedium};
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  background-color: ${primaryColor};
  border: 1px solid ${primaryColor};
  border-radius: 8px;
  min-width: 100px;
  padding: 5px 10px;
  cursor: pointer;
  @media all and (max-width: ${maxWidth}), ${retina} {
    padding: 3px 7px;
    font-size: 13px;
    min-width: 90px;
  }
  @media all and (max-width: ${maxMobile}) {
    font-size: 13px;
    min-width: 40px;
    padding: 5px 8px;
    line-height: 14px;
    margin-left: 5px;
    border-radius: 6px;
  }
`;
type Props = {
  swotTab?: boolean,
  tabCheck?: boolean,
  redirectUrl?: string,
  disabledViewAction?: boolean,
  swotToggle?: () => void,

} & typeof defaultProps;

const defaultProps = {
  swotTab: false,
  tabCheck: false,
  redirectUrl: '',
  swotToggle: () => { },
  disabledViewAction: false,
};
const ViewSwitcher = function ViewSwitcher(props: Props) {
  const navigate = useNavigate();
  const {
    swotTab, redirectUrl, swotToggle, tabCheck, disabledViewAction,
  } = props;

  const handleClick = () => {
    if (swotTab) {
      swotToggle();
    } else {
      navigate(redirectUrl);
    }
    const element = document.querySelector('.tabSection') as HTMLElement;
    if (element) {
      setTimeout(() => {
        scrollWithId(element);
      }, 200);
    }
  };

  return (
    <Wrapper
      className={classNames('view-switcher-component', { disabledViewMore: disabledViewAction })}
      onClick={() => handleClick()}
      onKeyDown={() => handleClick()}
      tabIndex={0}
      role="button"
    >
      {!swotTab ? (
        <span
          className="viewAll"
          aria-label="view-all"
        >
          View all
        </span>
      ) : (
        <span
          className="viewAll"
          aria-label="view-all"
        >
          {tabCheck ? 'View less' : 'View all'}
        </span>
      )}
    </Wrapper>
  );
};
ViewSwitcher.defaultProps = defaultProps;
export default ViewSwitcher;
